import { render, staticRenderFns } from "./tabs-item.vue?vue&type=template&id=7b3ea867&scoped=true&lang=pug&"
import script from "./tabs-item.vue?vue&type=script&lang=js&"
export * from "./tabs-item.vue?vue&type=script&lang=js&"
import style0 from "./tabs.styl?vue&type=style&index=0&id=7b3ea867&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3ea867",
  null
  
)

export default component.exports